package com.starparty.app.astro0

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class SP_Place (var latitude: Double, var longitude: Double) {

/* Commented out because only used / works in Android version
    fun formattedLatitudeDecimal(decimalPlaces:Int): String {
        val decimalString = String.format("%.${decimalPlaces}f", latitude)

        var hemisphere = "N"
        if (latitude < 0) { hemisphere = "S"}

        val string = decimalString + " $hemisphere"
        return string
    }
    */
/*Commented out because only used / works in Android version
    fun formattedLongitudeDecimal(decimalPlaces:Int): String {
        val decimalString = String.format("%.${decimalPlaces}f", longitude)

        var hemisphere = "W"
        if (longitude < 0) { hemisphere = "E"}

        val string = decimalString + " $hemisphere"

        return string
    }
*/
}